import { useLocation } from "react-router-dom";
import { useModule } from "../contexts/ModuleContext";
import { useAuth } from "../contexts/AuthContext";
import * as Icons from "lucide-react";
import type { LucideIcon } from "lucide-react";

export const useScreenPermission = () => {
  const location = useLocation();
  const { getScreenIdByPath, getScreenByPath } = useModule();
  const { permissions } = useAuth();

  const moduleScreenId = getScreenIdByPath(location.pathname);
  const screen = getScreenByPath(location.pathname);

  const iconsMap = Icons as unknown as Record<string, LucideIcon>;

  const IconComponent =
    screen?.icon && iconsMap[screen.icon]
      ? iconsMap[screen.icon]
      : Icons.FolderX;

  const screenPermission =
    moduleScreenId && permissions
      ? permissions[moduleScreenId]
      : undefined;
 
  return {
    screenName: screen?.screenName || "",
    icon: IconComponent,
    
    canView: screenPermission?.view ?? false,
    canAdd: screenPermission?.add ?? false,
    canEdit: screenPermission?.edit ?? false,
    canDelete: screenPermission?.delete ?? false,
    canApprove: screenPermission?.approve ?? false,
  };
};